<template>
  <div>
    <!-- BANNER -->
    <div class="banner">
      <div class="banner-overlay box-overlay brand_primary_bg rounded-top-10">
        <img v-lazy="localImg(banner)" class="img img-luminous" />
      </div>
      <img v-lazy="localImg(display_img)" class="display-img" />
    </div>

    <!-- WELCOME BLOCK -->
    <div
      class="welcome-block w-100 d-flex flex-column justify-content-start align-items-center"
    >
      <div class="welcome-title font-weight-bold brand_navy">
        <template v-if="account_type === 'school' || account_type === 'teacher'"
          >Class activities at a Glance</template
        >
        <template v-if="account_type === 'parent'"
          >Keep Up with School</template
        >
      </div>

      <div class="welcome-text color_grey_dark text-center">
        <template v-if="account_type === 'school' || account_type === 'teacher'"
          >With Gradely’s Class Feed, you can monitor and particpate in all of
          your classes</template
        >
        <template v-if="account_type === 'parent'"
          >Connect your child’s school to add their homework and class
          activities to the report you see</template
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogTwo",

  props: ["banner", "display_img"],

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
    };
  },
};
</script>

<style>
</style>
